import { styled } from "styled-components";
import { useTheme } from "@wayflyer/flyui";
import { IconPlus32Line as PlusIcon } from "@wayflyer/flyui-icons/32/line";

const BlankInputButton = styled.button`
  cursor: pointer;
  width: 88px;
  height: 88px;
  border: 2px dashed var(--palette-border-neutral-subtle);
  color: var(--palette-border-neutral-subtle);
  background-color: inherit;
  border-radius: var(--sizes-radius-sm);
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:hover {
    color: var(--palette-content-neutral-subtle);
    border: 2px dashed var(--palette-content-status-positive);

    svg {
      color: var(--palette-content-status-positive);
    }
  }
`;

export interface BankConnectCountryConfig {
  name: string;
  code: string;
  confirmEmail?: boolean;
  providerName?: string;
}

export type BankConnectFunction =
  | ((data?: BankConnectCountryConfig) => void)
  | ((data?: BankConnectCountryConfig) => Promise<void>);

export interface ConnectBankButtonProps {
  /* Props go here */
  startConnect: BankConnectFunction;
}

/**
 * ConnectBankButton component
 */
export const ConnectBankButton = ({ startConnect }: ConnectBankButtonProps) => {
  const theme = useTheme();
  return (
    // TODO: Type for click handler is incorrect, only started failing when
    // button changed from `BaseButton` to `button`.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <BlankInputButton aria-label="Connect Bank" onClick={startConnect} theme={theme}>
      <PlusIcon />
    </BlankInputButton>
  );
};
